<template>
	<page-template>
		<div class="dashboard-wrapper">
			<div class="inside-wrapper">
				<group-layout title="매출">
					<card-component
						title="총 매출"
						:score="editable.total.sales"
						type="money"
						:only-read-mode="true"
					/>
				</group-layout>

				<group-layout title="회원">
					<card-component title="총 회원" :score="editable.total.user_count" :only-read-mode="true" />
				</group-layout>

				<group-layout title="주문">
					<card-component title="총 주문" :score="editable.total.order_count" :only-read-mode="true" />
				</group-layout>
			</div>

			<div class="option-wrapper">
				<div class="left-wrapper">
					<toggle-layout
						title="날짜"
						v-model="filter.period"
						:state-list="periodArray"
						:on-change-state="refreshDashboard"
					/>
				</div>

				<div class="right-wrapper">
					<date-pagination
						:start="pickedDates.start"
						:end="pickedDates.end"
						@start="value => pickedDates.start = value"
						@end="value => pickedDates.end = value"
						:on-start-selected="refreshDashboard"
						:on-end-selected="refreshDashboard"
					/>
				</div>
			</div>

			<div class="inside-wrapper">
				<chart-component :title="chartTitle" v-model="chartData" />
			</div>

			<div class="inside-wrapper">
				<group-layout title="매출">
					<card-component
						title="매출"
						:score="editable.sales.score || 0"
						type="money"
						v-model="cardState"
						state-name="sales"
						:on-click-event="refreshDashboard"
					/>
				</group-layout>

				<group-layout title="회원" class="user-2x-wrapper">
					<card-component
						title="신규 회원"
						:score="editable.users.score || 0"
						v-model="cardState"
						state-name="newUser"
						:on-click-event="refreshDashboard"
					/>
				</group-layout>
			</div>

			<div class="inside-wrapper">
				<div class="layout-wrapper">
					<p class="title">주문</p>

					<div class="inner-wrapper">
						<card-component
							title="전체"
							:score="editable.orders.all.score || 0"
							v-model="cardState"
							state-name="allOrder"
							class="item"
							:on-click-event="refreshDashboard"
						/>

						<card-component
							title="결제"
							:score="editable.orders.payed.score || 0"
							v-model="cardState"
							state-name="payedOrder"
							class="item"
							:on-click-event="refreshDashboard"
						/>

						<card-component
							title="노쇼"
							:score="editable.orders.noshow.score || 0"
							v-model="cardState"
							state-name="noshowOrder"
							class="item"
							:on-click-event="refreshDashboard"
						/>

						<card-component
							title="취소"
							:score="editable.orders.cancel.score || 0"
							v-model="cardState"
							state-name="cancelOrder"
							class="item"
							:on-click-event="refreshDashboard"
						/>
					</div>
				</div>
			</div>
		</div>
	</page-template>
</template>

<script>
import PageTemplate from "@/spa/components/page-template/PageTemplate";
import ToggleLayout from "@/spa/components/LayoutToggle";
import DatePagination from "@/spa/components/LayoutDatePaginator";

import GroupLayout from "./components/GroupLayout";
import CardComponent from "./components/CardComponent";
import ChartComponent from "../../../../modules/chart/ChartComponent";

export default {
	name: "Dashboard",
	components: {
		ChartComponent,
		PageTemplate,
		ToggleLayout,
		CardComponent,
		GroupLayout,
		DatePagination
	},
	methods: {
		/*
    getMondayOfCurrentWeek(d) { 
      var day = d.getDay();  // (from 0 to 6) for the specified date.
      return new Date(d.getFullYear(), d.getMonth(), d.getDate() - day);
    },
    setPeriod() {
      let now = new Date().getUTCDate();
      this.pickedDates.end = now;
      if(this.filter.period == "일") {
        this.pickedDates.start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      }
      else if(this.filter.period == "주") {
        this.pickedDates.start = getMondayOfCurrentWeek(now);
      }
      else if(this.filter.period == "월") {
        this.pickedDates.start = new Date(now.getFullYear(), now.getMonth(), 1);
      }
      else if(this.filter.period == "년") {
        this.pickedDates.start = new Date.setYear(now.getDate()-30);
      }
    },
    */
		injectEditable({ total, sales, users, orders }) {
			this.editable = {
				total,
				sales,
				users,
				orders
			};
		},

		injectChart(state, period, data) {
			let list = [];

			switch (state) {
				case "sales":
					list = data.sales.result;
					this.chartTitle = "주문 가격 (원)";
					break;
				case "newUser":
					list = data.users.result;
					this.chartTitle = "신규 유저 (명)";
					break;
				case "allOrder":
					list = data.orders.all.result;
					this.chartTitle = "전체 주문 수 (건)";
					break;
				case "payedOrder":
					list = data.orders.payed.result;
					this.chartTitle = "결제 주문 수 (건)";
					break;
				case "noshowOrder":
					list = data.orders.noshow.result;
					this.chartTitle = "노쇼 주문 수 (건)";
					break;
				case "cancelOrder":
					list = data.orders.cancel.result;
					this.chartTitle = "취소 주문 수 (건)";
					break;
				default:
					break;
			}

			const dateList = list.map(item => item.date.split("T")[0]);
			const scoreList = name => list.map(item => item[name]) || [];
			const nowDate = [new Date().toISOString().split("T")[0]];

			const chartHeader = ["x", ...(dateList.length > 0 ? dateList : nowDate)];

			let result = {};

			if (state === "newUser") {
				let chartData = ["유저 수", ...scoreList("score")];

				if (dateList.length === 0) {
					chartData = [["user", 0]];
				}

				const unload = ["WP", "E24"];

				result = {
					data: {
						x: "x",
						columns: [chartHeader, chartData],
						unload
					}
				};
			} else {
				const wpList = scoreList("wp_store");
				const e24List = scoreList("cvs_e24");

				let arr1 = ["WP"];
				let arr2 = ["E24"];
				for (let item of wpList) {
					arr1.push(item);
				}
				for (let item of e24List) {
					arr2.push(item);
				}
				let chartData = [arr1, arr2];
				console.log("chartData", chartData);
				// let chartData = [
				// 	["WP", ...wpList],
				// 	["E24", ...e24List]
				// ];

				if (dateList.length === 0) {
					chartData = [
						["WP", 0],
						["E24", 0]
					];
				}

				const unload = ["유저 수"];

				result = {
					data: {
						x: "x",
						columns: [chartHeader, ...chartData],
						unload
					}
				};
			}

			this.chartData = result;
		},

		refreshChart() {
			this.injectChart(this.cardState, this.filter.period, this.editable);
		},

		async refreshDashboard() {
			// this.recalcPeriod();
			await this.$nextTick(async () => {
				const passedPeriod = { 일: "days", 월: "months", 년: "years" }[
					this.filter.period
				];
				console.log("refreshDashboard", JSON.stringify(this.pickedDates));
				var start = new Date(
					Date.UTC(
						this.pickedDates.start.getFullYear(),
						this.pickedDates.start.getMonth(),
						this.pickedDates.start.getDate(),
						-9
					)
				);
				var end = new Date(
					Date.UTC(
						this.pickedDates.end.getFullYear(),
						this.pickedDates.end.getMonth(),
						this.pickedDates.end.getDate(),
						24 - 9
					)
				);

				console.log("start", start.toUTCString());
				console.log("end", end.toUTCString());

				console.log("start obj", start);
				console.log("end obj", end);
				console.log("---------------");
				const result = await this.$store.dispatch("getDashboard", {
					period: passedPeriod,
					start: start,
					end: end
					// start: this.pickedDates.start,
					// end: this.pickedDates.end,
				});

				if (!result) return;

				this.injectEditable({
					total: result.total,
					sales: result.sales,
					users: result.users,
					orders: result.orders
				});

				this.refreshChart();
			});
		}
	},
	data() {
		return {
			filter: {
				period: "일",
				type: "전체"
			},
			periodArray: ["일", "월", "년"],
			typeArray: ["전체", "WP", "E24"],
			cardState: "sales",
			cardStateTable: {
				sales: "매출",
				newUser: "신규 유저",
				allOrder: "총 주문",
				noshowOrder: "노쇼",
				cancelOrder: "취소"
			},
			pickedDates: {
				start: new Date(
					Date.UTC(
						new Date().getFullYear(),
						new Date().getMonth(),
						new Date().getDate() - 30
					)
				),
				end: new Date(
					Date.UTC(
						new Date().getFullYear(),
						new Date().getMonth(),
						new Date().getDate()
					)
				)
			},
			editable: {
				sales: { score: 0, result: [] },
				users: { score: 0, result: [] },
				orders: {
					all: { score: 0, result: [] },
					payed: { score: 0, result: [] },
					noshow: { score: 0, result: [] },
					cancel: { score: 0, result: [] }
				},
				total: { sales: 0, order_count: 0, user_count: 0 }
			},
			chartData: {
				data: {
					x: "x",
					columns: {
						header: ["x", 0],
						data: ["data", 0]
					},
					unload: []
				},
				axis: {
					x: {
						type: "timeseries",
						tick: {
							format: "%Y/%m/%d"
						}
					}
				}
			},
			chartTitle: "주문 수 (건)"
		};
	},
	async mounted() {
		await this.refreshDashboard();
	}
};
</script>

<style lang="scss" scoped>
.dashboard-wrapper {
	padding: 20px;

	.inside-wrapper {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;

		margin: 0 auto;
		width: 100%;
		height: auto;

		.layout-wrapper {
			width: 100%;

			display: flex;
			flex-direction: column;
			align-items: flex-start;

			margin-top: 20px;
			margin-bottom: 20px;

			.title {
				font-size: 16px;
				color: rgba(0, 0, 0, 0.6);
			}

			.inner-wrapper {
				width: 100%;

				display: flex;
				flex-direction: row;
				align-items: flex-start;
				flex-wrap: wrap;

				.item {
					max-width: 320px;

					margin-top: 20px;
					margin-bottom: 20px;
					margin-right: 20px;
				}
			}
		}
	}

	.option-wrapper {
		position: relative;

		width: 100%;
		max-width: 1280px;

		display: flex;
		flex-direction: row;

		margin-top: 24px;
		margin-bottom: 24px;

		.left-wrapper {
			position: relative;
			left: 0;
			width: auto;
		}

		.right-wrapper {
			position: relative;

			right: 0;
			/*white-space: nowrap;*/

			margin-left: 48px;
		}
	}

	.reactive-element {
		flex-direction: row !important;
	}
}

@media screen and (max-width: 1024px) {
	.dashboard-wrapper {
		.inside-wrapper {
			justify-content: center;
			align-content: center;
			align-items: center;

			.layout-wrapper {
				width: 100%;
				max-width: none;

				.inner-wrapper {
					.item {
						width: 100%;
						max-width: none;
						margin-right: 0;
					}
				}
			}
		}

		.option-wrapper {
			flex-direction: column;
			justify-content: center;
			align-content: center;
			align-items: center;

			margin-bottom: 0;
			margin-top: 48px;

			width: 100%;

			.left-wrapper,
			.right-wrapper {
				display: flex;
				justify-content: flex-start;

				margin-bottom: 24px;
			}

			.right-wrapper {
				width: 100%;
				margin-left: 0;

				display: flex;
				flex-direction: column;
				justify-content: center;
				align-content: center;
				align-items: center;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/dashboard/Dashboard.vue